/* DUNTALK reviews: shows "Verified purchase on Etsy" as a small label under the
   reviewer's name for reviews imported from Etsy, instead of as a review title,
   and hides the review date on review cards. */
(function () {
  var LABEL = 'verified purchase on etsy';
  var SETS = [
    ['.jdgm-review-card', '.jdgm-review-card__title'],
    ['.jdgm-rev', '.jdgm-rev__title'],
    ['.jdgm-carousel-item', '.jdgm-carousel-item__review-title']
  ];
  var DATE = /^(\d{1,4}[\/.\-]\d{1,2}[\/.\-]\d{1,4}|[A-Za-z]{3,9}\.? \d{1,2},? \d{4}|\d{1,2} [A-Za-z]{3,9}\.?,? \d{4})$/;
  function hideDates(card) {
    var els = card.querySelectorAll('p, span, time');
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.children.length === 0 && !el.classList.contains('dt-rev-date') && DATE.test((el.textContent || '').trim())) {
        el.classList.add('dt-rev-date');
      }
    }
  }
  function mark() {
    SETS.forEach(function (set) {
      var cards = document.querySelectorAll(set[0]);
      for (var i = 0; i < cards.length; i++) {
        hideDates(cards[i]);
        var title = cards[i].querySelector(set[1]);
        var isEtsy = !!title && (title.textContent || '').trim().toLowerCase() === LABEL;
        if (isEtsy !== cards[i].classList.contains('dt-etsy')) {
          cards[i].classList.toggle('dt-etsy', isEtsy);
        }
      }
    });
  }
  var timer;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(mark, 120);
  }
  function start() {
    mark();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
